export type SupportedLanguage = 'kr' | 'en'

const STORAGE_LANGUAGE_KEY = 'selectedLanguage'

export const isSupportedLanguage = (
  value: string | null | undefined
): value is SupportedLanguage => value === 'kr' || value === 'en'

export const getLanguageFromQuery = (): SupportedLanguage | undefined => {
  try {
    const queryParams = new URLSearchParams(globalThis.location.search)
    const language = queryParams.get('lang')
    return isSupportedLanguage(language) ? language : undefined
  } catch {
    return undefined
  }
}

export const getLanguageFromStorage = (): SupportedLanguage | undefined => {
  try {
    const storedLanguage = globalThis.localStorage.getItem(STORAGE_LANGUAGE_KEY)
    return isSupportedLanguage(storedLanguage) ? storedLanguage : undefined
  } catch {
    return undefined
  }
}

export const setLanguageInStorage = (language: SupportedLanguage): void => {
  try {
    globalThis.localStorage.setItem(STORAGE_LANGUAGE_KEY, language)
  } catch {
    // no-op
  }
}

export const getBrowserLanguage = (): SupportedLanguage => {
  const browserLanguages = globalThis.navigator.languages || [
    globalThis.navigator.language || 'en',
  ]
  const hasKoreanLanguage = browserLanguages.some((language) =>
    language.toLowerCase().startsWith('ko')
  )

  return hasKoreanLanguage ? 'kr' : 'en'
}

export const resolveLanguagePreference = (): SupportedLanguage => {
  const queryLanguage = getLanguageFromQuery()
  if (queryLanguage) {
    setLanguageInStorage(queryLanguage)
    return queryLanguage
  }

  const storedLanguage = getLanguageFromStorage()
  if (storedLanguage) {
    return storedLanguage
  }

  return getBrowserLanguage()
}
